import fetch from '@/utils/fetch'

// 官网可售餐饮产品列表
export function loadSaleList (query) {
  return fetch({
    url: '/website/food/goods/find-allow-sale-list',
    method: 'post',
    data: query
  })
}

export function createGeneralOrder (data) {
  return fetch({
    url: '/website/food/order/create-general-order',
    method: 'post',
    data
  })
}

export function payConfirm (data) {
  return fetch({
    url: '/website/food/order/payment',
    method: 'post',
    data
  })
}

export function orderInfo (orderNo) {
  return fetch({
    url: '/website/food/order/order-detail/' + orderNo,
    method: 'post'
  })
}

export function orderReview (data) {
  return fetch({
    url: '/website/order-review/page',
    method: 'post',
    data
  })
}
